import { useQuery } from '@tanstack/react-query';
import axios from '../../utils/axiosInstance';
import { AssetStatus, AssetType, TaskStatus } from '../types';

export interface DashboardUpcomingTask {
  id: string;
  name: string;
  status: TaskStatus;
  due_date: string;
  campaign: string | null;
}

export interface DashboardSocialItem {
  id: number;
  publish_date: string;
  publish_time: string;
  caption: string;
  title: string;
  status: AssetStatus;
  asset_type: AssetType;
  /** 'Instagram' or 'Facebook' — derived server-side from asset_type. */
  platform: 'Instagram' | 'Facebook';
  campaign: string | null;
}

export interface DashboardPayload {
  active_campaigns: number;
  planned_campaigns: number;
  tasks_this_week: number;
  posts_next_7d: number;
  alerts_count: number;
  upcoming_tasks: DashboardUpcomingTask[];
  social_preview: DashboardSocialItem[];
}

export interface OverlapAlert {
  kind: 'brand_conflict' | 'sitewide_overlap';
  message: string;
  detail: string;
  campaign_ids: string[];
  brand_id: string | null;
}

export const useDashboard = () =>
  useQuery<DashboardPayload>({
    queryKey: ['dashboard'],
    queryFn: async () => (await axios.get('api/dashboard/')).data,
  });

export const useAlerts = () =>
  useQuery<OverlapAlert[]>({
    queryKey: ['alerts'],
    queryFn: async () => (await axios.get('api/alerts/')).data,
  });
